window.addEventListener("DOMContentLoaded", (e) => {
  /* Setting up size finder */
  sizeFinder.init();
});


let sizeFinder = {
  /* Props */
  /* Init data json ele and parsed data prop */
  sizeDataEle: document.getElementById("size-finder-data"),
  sizingData: {},

  /* Props for input > object storage */
  widthCM: 0,
  lengthCM: 0,

  /* Props for matched data */
  matchedSizeData: false,
  matchedWidth: false,

  /* Results Pane and Form Elements */
  resultsPane: document.getElementById("size-finder-results-pane"),
  sizeResultEle: document.getElementById("size-finder-results-size"),
  shopButtonEle: document.getElementById("shop-results-button"),
  sizeFinderFormEle: document.getElementById("size-finder-form"),
  sizeFinderInputs: document.querySelectorAll(".size-finder-form__input"),

  /* Input Element ID's */
  formEles: {
    widthEl: document.getElementById("size-finder-input-width"),
    lengthEl: document.getElementById("size-finder-input-length"),
    submitButton: document.getElementById("size-finder-submit-button"),
  },

  /* Error messages */
  sizeMatchErrorMessage: "",
  errorMessageDisplay: document.getElementById("size-finder-form__error-message"),
  errorLength: document.getElementById("size-finder-input-length-error"),
  errorWidth: document.getElementById("size-finder-input-width-error"),

  shopLink: "",
  /* End props */

  /* Decomposition Methods */
  init: function () {
    this.storeTranslatedErrorMessage();
    this.resetInputs();
    this.populateSizingDataFromJson();
    this.initializeInputHandlers();
    this.initializeSubmitHandler();
  },
  initializeSubmitHandler: function () {
    this.formEles.submitButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.resetInputValidation();

      if (this.inputsValidate()) {
        try {
          this.storeValuesFromInputs();
          this.matchDataFromStored();
          this.populateMatchedResults();
          this.showResultsPane();
          this.updateSubmitButtonPostSubmit();
        } catch (e) {
          this.hideResultsPane();
        }
      }
    });
  },
  initializeInputHandlers: function() {
    for ( let sizeFinderInput of this.sizeFinderInputs ) {
      sizeFinderInput.addEventListener('blur', (e) => {
        this.displayCustomError(e, e.target.checkValidity());
      })

      sizeFinderInput.addEventListener('keyup', (e) => {
        // Clear error messages on keyup only when valid
        if (e.target.checkValidity()) {
          this.displayCustomError(e, true)
        }

        if (this.inputsValidate()) {
          this.enableButton()
        } else {
          this.disableButton()
        }
      })
    }
  },
  enableButton: function() {
    this.formEles.submitButton.removeAttribute('disabled')
    this.formEles.submitButton.value = this.formEles.submitButton.dataset.validatedLanguage
  },
  disableButton: function() {
    this.formEles.submitButton.setAttribute('disabled','disabled')
    this.formEles.submitButton.value = this.formEles.submitButton.dataset.nonvalidatedLanguage
  },
  populateMatchedResults: function() {
    this.buildShopLink();
    this.populateLink();
    this.populateSizeDisplay();
  },
  matchDataFromStored: function() {
    this.matchSizeToInputData();
    this.matchWidthToData();
  },
  storeValuesFromInputs: function() {
    this.storeLengthValue();
    this.storeWidthValue();
  },

  /* Input and Validation Management */
  resetInputs: function () {
    this.formEles.widthEl.value = "";
    this.formEles.lengthEl.value = "";
  },
  resetInputValidation: function () {
    this.errorMessageDisplay.style.display = "none";
  },
  inputsHaveValues: function() {
    return this.formEles.widthEl.value.length && this.formEles.lengthEl.value.length
  },
  displayCustomError: function(e, isValid) {
    if (e.target.value === '') return

    const isWidth = e.target === this.formEles.widthEl;
    const targetErrorEl = isWidth ? this.errorWidth : this.errorLength;

    if (isValid) {
      e.target.classList.remove('invalid');
      targetErrorEl.innerHTML="";
    } else {
      e.target.classList.add('invalid');
      targetErrorEl.innerHTML= e.target.dataset.invalid;
    }
  },
  inputsValidate: function () {
    return this.formEles.widthEl.checkValidity() && this.formEles.lengthEl.checkValidity();
  },

  /* Results Pane and Submit Display Management */
  showResultsPane: function () {
    this.resultsPane.classList.add("display");
  },
  hideResultsPane: function () {
    this.resultsPane.classList.remove("display");
  },
  buildShopLink: function () {
    const sizeParam = this.matchedSizeData.age === 'bigKidShoeSize'
      ? 'filter.bigkid_shoe_size'
      : 'filter.littlekid_shoe_size'

    this.shopLink = `/search?${sizeParam}=${this.matchedSizeData.size}&filter.shoe_width=${this.matchedWidth}`;
  },
  populateLink: function () {
    this.shopButtonEle.setAttribute("href", this.shopLink);
  },
  populateSizeDisplay: function () {
    this.sizeResultEle.innerHTML =
      this.matchedSizeData.size + this.matchedWidth;
  },
  updateSubmitButtonPostSubmit: function() {
    this.formEles.submitButton.value = this.formEles.submitButton.dataset.submittedLanguage;
    this.formEles.submitButton.classList.remove('button--primary')
    this.formEles.submitButton.classList.add('button--secondary')
  },

  /* Data Management - Includes input > object storage and size matching management */
  storeTranslatedErrorMessage: function() {
    this.sizeMatchErrorMessage = this.sizeFinderFormEle.dataset.sizeMatchError;
  },
  populateSizingDataFromJson: function () {
    try {
      let sizingDataJSON = this.sizeDataEle.textContent;
      let sizingDataParsed = JSON.parse(sizingDataJSON);
      this.sizingData = sizingDataParsed;
    } catch (e) {
      console.error(e);
    }
  },
  matchSizeToInputData: function () {
    this.matchedSizeData = false;
    let currentLength;
    let previousLength = 0;

    this.sizingData.forEach((sizeElement, index) => {
      currentLength = sizeElement.lengthCM;

      if (this.lengthCM >= previousLength && this.lengthCM <= currentLength) {
        this.matchedSizeData = this.sizingData[index];

        previousLength = currentLength;
      }
    });

    if (!this.matchedSizeData || !this.matchedSizeData.age) {
      this.errorMessageDisplay.style.display = "block";
      throw "matchSizeToInputData: " + this.sizeMatchErrorMessage;
    }
  },
  matchWidthToData: function () {
    this.matchedWidth = false;

    for (let widthKey of ["M", "W", "XW"]) {
      if (this.widthCM <= this.matchedSizeData.width[widthKey]) {
        this.matchedWidth = widthKey;
        break;
      }
    }

    if (!this.matchedWidth) {
      this.errorMessageDisplay.style.display = "block";
      throw "matchWidthToData: " + this.sizeMatchErrorMessage;
    }
  },
  storeLengthValue: function () {
    this.lengthCM = parseFloat(this.formEles.lengthEl.value);
  },
  storeWidthValue: function () {
    this.widthCM = parseFloat(this.formEles.widthEl.value);
  },
};